import { render, staticRenderFns } from "./booking-card-candidate.vue?vue&type=template&id=df2fee18&scoped=true&"
import script from "./booking-card-candidate.vue?vue&type=script&lang=js&"
export * from "./booking-card-candidate.vue?vue&type=script&lang=js&"
import style0 from "./booking-card-candidate.vue?vue&type=style&index=0&id=df2fee18&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df2fee18",
  null
  
)

export default component.exports